/**
 * Create Game Page Component
 * 
 * Protected page that wraps the PayoutStructureBuilder with navigation
 * controls and user context. Allows authenticated users to create and
 * analyze new pull tab games.
 * 
 * Features:
 * - Navigation header with back to dashboard functionality
 * - User-aware interface with logout capability
 * - Integration with PayoutStructureBuilder for game creation
 * - Responsive layout with consistent styling
 * - Protected route requiring authentication
 */

import { useNavigate } from 'react-router-dom';
import PayoutStructureBuilder from '../features/payouts/PayoutStructureBuilder';
import { useAuth } from '../hooks/useAuth';
import Logo from '../components/Logo';
import MobileMenu from '../components/MobileMenu';

export default function CreateGame() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-emerald-50 to-amber-50">
      <header className="bg-white shadow-sm border-b border-tp-brand/20">
        <div className="container mx-auto px-2 tablet:px-4 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <Logo className="w-[200px] h-auto flex-shrink-0" />
              <div className="hidden tablet:block">
                <button
                  onClick={handleBackToDashboard}
                  className="text-tp-brand hover:text-tp-leaf font-medium transition-colors"
                >
                  ← Dashboard
                </button>
              </div>
            </div>
            {/* Desktop Menu */}
            <div className="hidden tablet:flex items-center gap-4">
              <span className="text-tp-line">Welcome, {user?.name}</span>
              <button
                onClick={handleLogout}
                className="text-tp-line hover:text-tp-brand text-base tablet:text-sm transition-colors"
              >
                Sign Out
              </button>
            </div>

            {/* Mobile Menu */}
            <div className="tablet:hidden">
              <MobileMenu />
            </div>
          </div>

          {/* Mobile back button */}
          <div className="tablet:hidden mt-3 pt-3 border-t border-tp-brand/10">
            <button
              onClick={handleBackToDashboard}
              className="text-tp-brand hover:text-tp-leaf font-medium transition-colors"
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </header>

      <main>
        <PayoutStructureBuilder />
      </main>
    </div>
  );
}